module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "fluid": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 pa-5 blue-grey white--text"
  }, [_vm._v("123")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 pa-5 green white--text"
  }, [_vm._v("234")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 pa-5 green white--text"
  }, [_vm._v("234")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 pa-5 green white--text"
  }, [_vm._v("234")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 pa-5 green white--text"
  }, [_vm._v("234")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 pa-5 green white--text"
  }, [_vm._v("234")])], 1)], 1)], 1)
},staticRenderFns: []}